import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {},
  homeTab: "dashboard",
  page: 1,
  // Step Master config, loaded once on app open and shared across components.
  stepMaster: [],
  stepMasterLoaded: false,
};

export const cfApprovalV2Slice = createSlice({
  name: "cfApprovalV2",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.page = 1;
    },
    removeFilter: (state, action) => {
      const key = action.payload;
      if (key === "date") {
        delete state.filters.dateFrom;
        delete state.filters.dateTo;
      } else {
        delete state.filters[key];
      }
      state.page = 1;
    },
    setHomeTab: (state, action) => {
      state.homeTab = action.payload;
      state.page = 1;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setStepMaster: (state, action) => {
      state.stepMaster = action.payload || [];
      state.stepMasterLoaded = true;
    },
  },
});

export const { setFilters, removeFilter, setHomeTab, setPage, setStepMaster } = cfApprovalV2Slice.actions;
export default cfApprovalV2Slice.reducer;
